import React, { JSX } from 'react';
import { Box } from '@chakra-ui/react';
import { ScannedRelevosContextProvider } from 'contexts/ScannedRelevosContext';

import { MainPageContent } from '../../common/components/MainPageContent';
import MainPageHeading from '../../common/components/MainPageHeading/MainPageHeading';
import { NoLiveLocationsHeader } from '../../common/components/NoActiveLocationsHeader/NoLiveLocationsHeader';
import { useTranslations } from '../../contexts/LocalizationContext';
import { useRestaurantsData } from '../../services/restaurants';
import { ScannerMode } from './model/enums/scanner-mode.enum';
import { Assign } from './Assign';

const AssignRelevo = (): JSX.Element => {
  const translations = useTranslations();
  const { restaurantIds } = useRestaurantsData();

  return (
    <MainPageContent>
      {restaurantIds.length ? (
        <Box mb={2}>
          <MainPageHeading>{translations('relevos_assign_heading')}</MainPageHeading>
          <ScannedRelevosContextProvider mode={ScannerMode.ASSIGN}>
            <Assign />
          </ScannedRelevosContextProvider>
        </Box>
      ) : (
        <NoLiveLocationsHeader />
      )}
    </MainPageContent>
  );
};

export default AssignRelevo;
